import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f325439"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule__heading" }
const _hoisted_2 = { class: "schedule__mobile" }

import { computed, ref, provide } from 'vue';
import { storeToRefs } from 'pinia';
import { useAnniversary, useInfo } from '@/store';
import { useI18n } from 'vue-i18n';
import { isPC } from '@/hooks/useCheck';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
import ScheduleItem from './ScheduleItem.vue';
type ActiveSwiperBtnType = 'next' | 'prev' | null;

export default /*#__PURE__*/_defineComponent({
  __name: 'Schedule',
  setup(__props) {

_useCssVars(_ctx => ({
  "2e1598ed": (_unref(bg).pc),
  "fb63e2c8": (_unref(bg).mobile),
  "3e83e0a6": (_unref(mask).pc),
  "3557c7a7": (_unref(arrow).pc),
  "0a206641": (_unref(arrowActive).pc)
}))

const { t } = useI18n();
const { scheduleEvents, firstEventIndex } = storeToRefs(useAnniversary());
const modules = [Navigation];
const navigation = {
  nextEl: '.schedule .swiper-button-next',
  prevEl: '.schedule .swiper-button-prev',
};
const isTooltipVisible = ref(false);
let timeout: any = null;
const showTooltip = (show: boolean) => {
  isTooltipVisible.value = show;
  if (show) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      isTooltipVisible.value = false;
    }, 2000);
  }
  if (!show) {
    clearTimeout(timeout);
  }
};
const checkEl = ($event: any) => {
  if ($event.target.className !== 'prize') {
    showTooltip(false);
  }
};
const activeBtnType = ref<ActiveSwiperBtnType>(null);
const updateActiveSwiperBtnType = (type: ActiveSwiperBtnType) => {
  activeBtnType.value = type;
};
provide('tooltip', {
  isTooltipVisible,
  showTooltip,
});
const checkDirection = computed(() => {
  const lang = document.documentElement.lang;
  return lang === 'ar' || lang === 'ur' ? 'rtl' : 'ltr';
});
const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('anniversary_pc_schedule_bg')})`,
  mobile: `url(${getImg('anniversary_mobile_schedule_bg')})`,
}));
const mask = computed(() => ({
  pc: `url(${getImg('anniversary_pc_schedule_mask')})`,
}));
const arrow = computed(() => ({
  pc: `url(${getImg('anniversary_pc_arrow')})`,
}));
const arrowActive = computed(() => ({
  pc: `url(${getImg('anniversary_pc_arrow_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(scheduleEvents).length > 0)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(['schedule', { pc: _unref(isPC), 'non-mask': _unref(scheduleEvents).length <= 5 }]),
        onClick: checkEl
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('IW_P2_EVENT_SCHEDULE') || 'IW_P2_EVENT_SCHEDULE'), 1),
        _createVNode(_unref(Swiper), {
          navigation: navigation,
          modules: modules,
          slidesPerView: 5,
          initialSlide: _unref(firstEventIndex),
          allowTouchMove: false,
          dir: _unref(checkDirection)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scheduleEvents), (event, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createVNode(ScheduleItem, {
                    top: index % 2 === 0 ? 'text' : 'figure',
                    index: index,
                    deeplink: event.deeplink,
                    title: event.title,
                    startTime: event.startTime,
                    endTime: event.endTime,
                    prizeImage: event.prizeImage,
                    prizeName: event.prizeName,
                    status: event.status
                  }, null, 8, ["top", "index", "deeplink", "title", "startTime", "endTime", "prizeImage", "prizeName", "status"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["initialSlide", "dir"]),
        _createElementVNode("div", {
          class: _normalizeClass(['swiper-button-next', { active: activeBtnType.value === 'next' }]),
          onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (updateActiveSwiperBtnType('next'))),
          onTouchend: _cache[1] || (_cache[1] = ($event: any) => (updateActiveSwiperBtnType(null))),
          onTouchcancel: _cache[2] || (_cache[2] = ($event: any) => (updateActiveSwiperBtnType(null)))
        }, null, 34),
        _createElementVNode("div", {
          class: _normalizeClass(['swiper-button-prev', { active: activeBtnType.value === 'prev' }]),
          onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (updateActiveSwiperBtnType('prev'))),
          onTouchend: _cache[4] || (_cache[4] = ($event: any) => (updateActiveSwiperBtnType(null))),
          onTouchcancel: _cache[5] || (_cache[5] = ($event: any) => (updateActiveSwiperBtnType(null)))
        }, null, 34),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scheduleEvents), (event, index) => {
            return (_openBlock(), _createBlock(ScheduleItem, {
              key: index,
              top: index % 2 === 0 ? 'figure' : 'text',
              index: index,
              deeplink: event.deeplink,
              title: event.title,
              startTime: event.startTime,
              endTime: event.endTime,
              prizeImage: event.prizeImage,
              prizeName: event.prizeName,
              status: event.status
            }, null, 8, ["top", "index", "deeplink", "title", "startTime", "endTime", "prizeImage", "prizeName", "status"]))
          }), 128))
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})